<template>
  <component :is="template"></component>
</template>

<script>
import { STORE_KEY } from "./_store/constants";
import store from "./_store";
import ClassList from "./_components/ClassList";
import ClassSubjectDetail from "./_components/ClassSubjectDetail";
import ClassPartDetail from "./_components/ClassPartDetail";
import ClassStatistic from "./_components/ClassStatistic";

export default {
  name: "ClassModule",
  components: {
    ClassList,
    ClassSubjectDetail,
    ClassPartDetail,
    ClassStatistic,
  },
  props: {
    template: String
  },
  created() {
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
}
</script>
